import { useQuery } from '@tanstack/react-query';
import { getVersions } from 'api/versions.service';
import { useToast } from 'hooks/ui';
import { useEffect } from 'react';
import { setVersions, useVersionsStore } from 'store/versions';

const VERSIONS_FETCH_ERROR_MESSAGE = 'Error occured while fetching versions';
const FRONTEND_VERSION_KEY = 'frontend: ';
const BOT_VERSION_KEY = 'bot: ';
const BACKEND_VERSION_KEY = 'backend: ';

export const useVersionsGetQuery = () => {
  const toast = useToast();
  const versions = useVersionsStore((state) => state.versions);
  const FRONTEND_VERSION_TO_DISPLAY = `${FRONTEND_VERSION_KEY}${
    process.env.REACT_APP_CI_COMMIT_TAG || ''
  }`;

  const { isLoading, data, error } = useQuery({
    queryKey: ['version'],
    queryFn: getVersions,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: false,
    retry: 1,
  });

  useEffect(() => {
    if (data) {
      const { bot, backend } = data;

      setVersions({
        bot: bot || BOT_VERSION_KEY,
        backend: backend || BACKEND_VERSION_KEY,
        frontend: FRONTEND_VERSION_TO_DISPLAY,
      });
    }
  }, [data, FRONTEND_VERSION_TO_DISPLAY]);

  useEffect(() => {
    if (error) {
      setVersions(null);
      if (error) {
        toast.error(VERSIONS_FETCH_ERROR_MESSAGE);
      }
    }
  }, [error, toast]);

  return { isLoading, versions };
};
